import { render } from "./ExerciseSolution.vue?vue&type=template&id=600e4398&ts=true"
import script from "./ExerciseSolution.vue?vue&type=script&lang=ts"
export * from "./ExerciseSolution.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__